module.exports = __webpack_public_path__ + "static/p4-8063f29e34c6b020f99dbc46e226dcf3.jpg";